import { Observable } from "rxjs";
import { BaseResponse } from "src/app/core/models";
import { CreateGroupRequestModel, Group, UpdateGroupRequestModel, GroupsApiWrapper } from "src/app/core/models/selfcare/group";

export abstract class GroupsData {
    abstract createGroup(request: CreateGroupRequestModel): Observable<BaseResponse<Group>>;
    abstract getAllGroups(): Observable<BaseResponse<GroupsApiWrapper>>;
    abstract getGroupById(id: number): Observable<BaseResponse<Group>>;
    abstract updateGroup(request: UpdateGroupRequestModel): Observable<BaseResponse<Group>>;
    abstract deleteGroup(id: number): Observable<BaseResponse<boolean>>;
}
